module.exports = __webpack_public_path__ + "img/productivity-square-1.f3fcd8db.jpg";